import { useState, useEffect } from 'react';
import { getScenarios } from '../api/alphaApi';
import { Scenario } from '../types/alpha.types';

export const useScenarios = () => {
  const [scenarios, setScenarios] = useState<Scenario[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchScenarios = async () => {
      try {
        const data = await getScenarios();
        setScenarios(data);
      } catch (err) {
        setError('Failed to load scenarios');
      } finally {
        setIsLoading(false);
      }
    };

    fetchScenarios();
  }, []);

  return { scenarios, isLoading, error };
};